/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Hide(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 24 24'
        >
            <svg
                fill={iconColor || 'none'}
                height='20'
                width='23'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M11.4844 16.7599C5.73229 16.7599 1.0598 11.2109 0.183712 10.1028C0.0645921 9.95488 0 9.77346 0 9.5868C0 9.40014 0.0645921 9.21872 0.183712 9.07081C1.0598 7.93733 5.72344 2.37988 11.4844 2.37988C17.2454 2.37988 21.9267 7.93733 22.8028 9.05389L22.847 9.11311C22.9403 9.25032 22.99 9.41046 22.99 9.57411C22.99 9.73777 22.9403 9.89791 22.847 10.0351C21.9267 11.2109 17.2631 16.7599 11.4844 16.7599ZM11.4844 3.22577C6.17476 3.22577 1.75006 8.50407 0.865116 9.56142C1.75006 10.6442 6.17476 15.914 11.4844 15.914C16.794 15.914 21.2187 10.6442 22.1037 9.5868C21.263 8.50407 16.8471 3.22577 11.4844 3.22577Z'
                    fill={iconColor || '#375073'}
                />
                <path
                    d='M11.4845 14.6536C10.4343 14.6536 9.40777 14.356 8.53461 13.7983C7.66144 13.2406 6.98089 12.4479 6.57902 11.5206C6.17714 10.5932 6.07199 9.57269 6.27687 8.58818C6.48174 7.60367 6.98744 6.69934 7.73 5.98955C8.47257 5.27975 9.41866 4.79638 10.4486 4.60055C11.4786 4.40472 12.5462 4.50522 13.5164 4.88936C14.4866 5.2735 15.3159 5.92401 15.8993 6.75864C16.4827 7.59327 16.7941 8.57452 16.7941 9.57832C16.7941 10.9244 16.2347 12.2153 15.239 13.1671C14.2432 14.1189 12.8927 14.6536 11.4845 14.6536ZM11.4845 5.34891C10.6094 5.34891 9.75389 5.59696 9.02625 6.06169C8.29861 6.52643 7.73149 7.18697 7.39659 7.9598C7.0617 8.73262 6.97408 9.58301 7.1448 10.4034C7.31553 11.2239 7.73694 11.9775 8.35575 12.569C8.97455 13.1605 9.76296 13.5633 10.6213 13.7265C11.4796 13.8897 12.3692 13.8059 13.1777 13.4858C13.9863 13.1657 14.6773 12.6236 15.1635 11.9281C15.6497 11.2325 15.9092 10.4148 15.9092 9.57832C15.9092 8.45661 15.443 7.38084 14.6132 6.58767C13.7834 5.79451 12.658 5.34891 11.4845 5.34891Z'
                    fill={iconColor || '#375073'}
                />
                <line
                    stroke={iconColor || '#375073'}
                    x1='1.6666'
                    x2='20.6666'
                    y1='18.6274'
                    y2='1.62738'
                />
                <line
                    stroke='white'
                    x1='1.6666'
                    x2='22.1607'
                    y1='19.6274'
                    y2='1.29052'
                />
            </svg>
        </SvgIcon>
    );
}